import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "3.1.6 Добавление нового подписанта", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, " 3.1.8 Введите паспортные данные нового подписанта ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, "Номер", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Серия", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Кем выдан", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Дата выдачи", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Код подразделения", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Где зарегистрирован", -1)
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_proxy_list = _resolveComponent("v-menu-proxy-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_proxy_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите номер",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeDM.signatory_options_tpm.signatory_passport_number) = $event)),
        maxlength: "6",
        onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
      }, null, 512), [
        [_vModelText, _ctx.storeDM.signatory_options_tpm.signatory_passport_number]
      ]),
      _hoisted_7,
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите серию",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeDM.signatory_options_tpm.signatory_passport_seria) = $event)),
        maxlength: "5",
        onkeypress: "return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 32"
      }, null, 512), [
        [_vModelText, _ctx.storeDM.signatory_options_tpm.signatory_passport_seria]
      ]),
      _hoisted_9,
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите кем выдан",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storeDM.signatory_options_tpm.signatory_passport_issued) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.signatory_options_tpm.signatory_passport_issued]
      ]),
      _hoisted_11,
      _hoisted_12,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите дату выдачи",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeDM.signatory_options_tpm.signatory_when_issued) = $event)),
        maxlength: "10",
        onkeypress: "return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
      }, null, 512), [
        [_vModelText, _ctx.storeDM.signatory_options_tpm.signatory_when_issued]
      ]),
      _hoisted_13,
      _hoisted_14,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите код подразделения",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.storeDM.signatory_options_tpm.signatory_division_code) = $event)),
        maxlength: "7",
        onkeypress: "return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 45"
      }, null, 512), [
        [_vModelText, _ctx.storeDM.signatory_options_tpm.signatory_division_code]
      ]),
      _hoisted_15,
      _hoisted_16,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите место регистрации",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.storeDM.signatory_options_tpm.signatory_passport_registration) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.signatory_options_tpm.signatory_passport_registration]
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_17)
  ], 64))
}